export default __webpack_public_path__ + "static/media/node.454eb4e5.svg";